import { storeToRefs } from 'pinia';

import { useAuthStore } from '~/stores/auth';
import { BLACKLISTED_EMAILS } from '~/config/blacklist';

export default defineNuxtRouteMiddleware(() => {
  const authStore = useAuthStore();
  const { user } = storeToRefs(authStore);

  if (user.value && BLACKLISTED_EMAILS.includes(user.value?.email)) {
    return navigateTo({ name: 'chats' });
  }
});
